module.exports = __webpack_public_path__ + "img/tkbgc@2x.0a09d17d.png";